import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import store from './store'
import router from './router'
import permission from './utils/permission'
import { MAP_KEY, LICENSE_CODE } from '@/config/setting'
import EleAdmin from 'ele-admin'
import VueClipboard from 'vue-clipboard2'
import i18n from './i18n'
import './styles/index.scss'
import elementPatch from '@/utils/element-patch'

Vue.config.productionTip = false

Vue.use(EleAdmin, {
  response: {
    dataName: 'list'
  },
  mapKey: MAP_KEY,
  license: LICENSE_CODE,
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(permission).use(elementPatch).use(VueClipboard)

Vue.prototype.$bus = new Vue()

const { BASE_URL, VUE_APP_MODE, NODE_ENV } = process.env

async function getConfig () {
  return axios.get(BASE_URL + `json/config.json`).then((res) => {
    let data = res.data[VUE_APP_MODE]
    let config = data[NODE_ENV]
    Vue.prototype.$appConfig = config
    window.appConfig = config
  })
}

async function createApp () {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
  }).$mount('#app')
}

; (async function () {
  await getConfig();
  await createApp();
})()
